import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import useFetch from "../services/employeeService";
import { useFormik } from "formik";
import * as yup from "yup";
import Controls from "../components/controls/Controls";
import TextField from "@material-ui/core/TextField";
import { useForm, Form } from "../components/useForm";
import * as employeeService from "../services/employeeService";
import * as data from "../services/data";

const genderItems = [
  { id: "male", title: "Male" },
  { id: "female", title: "Female" },
];

const validationSchema = yup.object({
  firstName: yup
    .string("Enter your first name")
    .required("First name is required"),
  lastName: yup
    .string("Enter your first name")
    .required("First name is required"),
  phone: yup
    .string("Enter your phone number")
    .required("Phone number is required"),
  NIC: yup
    .string("Enter your id card number")
    .required("Id card number is required"),
  address: yup.string("Enter your address").required("Address is required"),
  district: yup.string("Enter your district").required("District is required"),
  dsDivision: yup
    .string("Enter your DS division")
    .required("DS division is required"),
  dateOfBirth: yup
    .date("Enter")
    // .min(new Date("2010-10-01"), "date min")
    .required("Date of birth is required"),
  gender: yup
    .mixed("Select your gender")
    .oneOf(["male", "female"])
    .required("Gender is required"),
  isOrganic: yup.boolean().required("required"),
  isNonOrganic: yup.boolean().required("required"),
});

export default function FarmerForm(props) {
  const {
    addOrEdit,
    recordForEdit,
    lat,
    long,
    profilePhotoSaved,
    farmlandPhotoSaved,
  } = props;
  const [profilePhoto, setProfilePhoto] = useState(profilePhotoSaved);
  const [farmlandPhoto, setFarmlandPhoto] = useState(farmlandPhotoSaved);
  const formik = useFormik({
    initialValues: {
      // id: 0,
      firstName: "",
      lastName: "",
      // email: "",
      phone: "",
      NIC: "",
      address: "",
      district: "",
      dsDivision: "",
      dateOfBirth: new Date(),
      lat: lat || null,
      long: long || null,
      profilePhoto: null,
      farmlandPhoto: null,
      gender: "male",
      isOrganic: false,
      isNonOrganic: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (values.profilePhoto && values.profilePhoto.startsWith("agco"))
        values.profilePhoto = null;
      if (values.farmlandPhoto && values.farmlandPhoto.startsWith("agco"))
        values.farmlandPhoto = null;
      if (!values.coordinates && !values.lat && !values.long) {
        values.lat = null;
        values.long = null;
      }
      const updateData = {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        NIC: values.NIC,
        address: values.address,
        district: values.district,
        dsDivision: values.dsDivision,
        dateOfBirth: values.dateOfBirth,
        lat: values.lat,
        long: values.long,
        profilePhoto: values.profilePhoto,
        farmlandPhoto: values.farmlandPhoto,
        gender: values.gender,
        isOrganic: values.isOrganic,
        isNonOrganic: values.isNonOrganic,
      };
      // console.log("values", values);
      let id;
      // alert(JSON.stringify(values, null, 2));
      if (values.id) addOrEdit(updateData, (id = values.id), formik.resetForm);
      if (!values.id) addOrEdit(values, (id = null), formik.resetForm);
    },
  });
  if (lat || long) {
    formik.values.lat = lat;
    formik.values.long = long;
  }

  // const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
  //   useForm(formik.initialFValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (validate()) {
    //   addOrEdit(values, resetForm);
    // }
  };
  const updateFarmlandPhoto = (photo) => {
    // // to convert the passing photo which is type of blob to datauri
    // const reader = new FileReader();
    // reader.addEventListener("load", () => {
    //   setFarmlandPhoto(reader.result);
    // });
    // reader.readAsDataURL(photo);  // to convert the passing photo which is type of blob to datauri
    setFarmlandPhoto(photo);
    formik.values.farmlandPhoto = photo;
    formik.setValues({
      ...formik.values,
      farmlandPhoto: photo,
    });
    // console.log("updated farmland photo", photo, farmlandPhoto, formik.values);
  };
  const updateProfilePhoto = (photo) => {
    // const reader = new FileReader();
    // reader.addEventListener("load", () => {
    //   setProfilePhoto(reader.result);
    // });
    // reader.readAsDataURL(photo);  // to convert the passing photo which is type of blob to datauri
    setProfilePhoto(photo);
    formik.values.profilePhoto = photo;
    formik.setValues({
      ...formik.values,
      profilePhoto: photo,
    });
    // console.log("updated profile photo", photo, formik.values);
  };
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // formik.initialValues.lat = position.coords.latitude;
          // formik.initialValues.long = position.coords.longitude;
          formik.values.lat = position.coords.latitude;
          formik.values.long = position.coords.longitude;
          formik.setValues({
            ...formik.values,
          });
          // console.log(formik.values);
        },
        (error) => {
          if (error.code == 0) {
            alert("Unknown error occurred.");
          } else if (error.code == 1) {
            alert(
              "Permission denied. You cannot get latitude & longitude until you allow to access your loocation."
            );
          } else if (error.code == 2) {
            alert(
              "Position unavailable. Error response from location provider."
            );
          } else if (error.code == 3) {
            alert("Location data request timed out.");
          }
        },
        { timeout: 10 * 1000 }
      );
      // console.log('this.formdata.lat', this.formdata.lat)
      // console.log('this.formdata.lat', position.coords.latitude)
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    if (recordForEdit != null) {
      formik.setValues({
        ...recordForEdit,
      });
    }
  }, []);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Controls.Input
            id="firstName"
            name="firstName"
            label="First Name"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
          />
          <Controls.Input
            name="lastName"
            label="Last Name"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
          />
          <Controls.Select
            name="district"
            size="small"
            label="District"
            options={employeeService.getDistrictsCollection()}
            value={formik.values.district}
            onChange={formik.handleChange}
            error={formik.touched.district && Boolean(formik.errors.district)}
            helperText={formik.touched.district && formik.errors.district}
          />
          {/* <Controls.GroupedSelect
            name="district"
            label="District"
            options={data.getCitiesCollection()}
            value={formik.values.district}
            onChange={formik.handleChange}
            error={formik.touched.district && Boolean(formik.errors.district)}
            helperText={formik.touched.district && formik.errors.district}
          /> */}
          {/* <Controls.AutoComplete
            id="district"
            label="District"
            options={employeeService.getDistrictsCollection()}
            value={formik.values.district}
            getOptionLabel={(option) => option.title}
            getOptionSelected={(option, value) => option.title === value.title}
            onChange={formik.handleChange}
            error={formik.touched.district && Boolean(formik.errors.district)}
            helperText={formik.touched.district && formik.errors.district}
          /> */}
          <Controls.Input
            label="NIC No"
            name="NIC"
            value={formik.values.NIC}
            onChange={formik.handleChange}
            error={formik.touched.NIC && Boolean(formik.errors.NIC)}
            helperText={formik.touched.NIC && formik.errors.NIC}
          />
          <Controls.Input
            label="Phone"
            name="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
            error={formik.touched.phone && Boolean(formik.errors.phone)}
            helperText={formik.touched.phone && formik.errors.phone}
          />
          <Controls.Input
            label="Address"
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            error={formik.touched.address && Boolean(formik.errors.address)}
            helperText={formik.touched.address && formik.errors.address}
          />
          <Controls.Input
            label="DS division"
            name="dsDivision"
            value={formik.values.dsDivision}
            onChange={formik.handleChange}
            error={
              formik.touched.dsDivision && Boolean(formik.errors.dsDivision)
            }
            helperText={formik.touched.dsDivision && formik.errors.dsDivision}
          />
          <Controls.DatePicker
            name="dateOfBirth"
            label="Date of Birth"
            value={formik.values.dateOfBirth}
            maxDate={new Date("2006-12-31")}
            minDate={new Date("1950-01-01")}
            onChange={formik.handleChange}
            error={
              formik.touched.dateOfBirth && Boolean(formik.errors.dateOfBirth)
            }
            helperText={formik.touched.dateOfBirth && formik.errors.dateOfBirth}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.RadioGroup
            name="gender"
            label="Gender"
            value={formik.values.gender}
            onChange={formik.handleChange}
            error={formik.touched.gender && Boolean(formik.errors.gender)}
            helperText={formik.touched.gender && formik.errors.gender}
            items={genderItems}
          />
          <Controls.Checkbox
            name="isOrganic"
            label="is Organic"
            value={formik.values.isOrganic}
            onChange={formik.handleChange}
            error={formik.touched.isOrganic && Boolean(formik.errors.isOrganic)}
            helperText={formik.touched.isOrganic && formik.errors.isOrganic}
          />
          <Controls.Checkbox
            name="isNonOrganic"
            label="is Non Organic"
            value={formik.values.isNonOrganic}
            onChange={formik.handleChange}
            error={
              formik.touched.isNonOrganic && Boolean(formik.errors.isNonOrganic)
            }
            helperText={
              formik.touched.isNonOrganic && formik.errors.isNonOrganic
            }
          />
          {formik.values.lat && (
            <Controls.Input
              label="Latitude"
              name="lat"
              value={formik.values.lat}
              onChange={formik.handleChange}
              // error={formik.touched.address && Boolean(formik.errors.address)}
              // helperText={formik.touched.address && formik.errors.address}
            />
          )}
          {formik.values.long && (
            <Controls.Input
              label="Longitude"
              name="long"
              value={formik.values.long}
              onChange={formik.handleChange}
              // error={formik.touched.address && Boolean(formik.errors.address)}
              // helperText={formik.touched.address && formik.errors.address}
            />
          )}
          <Controls.Button
            text="Get Location"
            color="default"
            onClick={() => {
              getLocation();
            }}
          />
          <Controls.UploadButton
            id="ProfilePhotoUploadButton"
            text="Upload Profile Photo"
            updatePhotoUrl={updateProfilePhoto}
          />
          <Paper elevation={3} style={{ width: "210px" }}>
            {profilePhoto && (
              <img
                src={profilePhoto}
                width="200px"
                height="200px"
                alt="Profile"
                style={{ margin: "5px", marginBottom: "0px" }}
              />
            )}
          </Paper>
          <Controls.UploadButton
            id="FarmlandPhotoUploadButton"
            text="Upload Farmland Photo"
            updatePhotoUrl={updateFarmlandPhoto}
          />
          <Paper elevation={3} style={{ width: "210px" }}>
            {farmlandPhoto && (
              <img
                src={farmlandPhoto}
                width="200px"
                height="200px"
                alt="Profile"
                style={{ margin: "5px", marginBottom: "0px" }}
              />
            )}
          </Paper>
        </Grid>
        <div>
          <Controls.Button type="submit" text="Submit" />
          <Controls.Button
            text="Reset"
            color="default"
            onClick={() => {
              formik.resetForm();
            }}
          />
        </div>
      </Grid>
    </Form>
  );
}
